import {
  GET_ACCESS_KEYS,
  GET_PROJECT,
  GET_PROJECT_ANALYTICS,
  GET_PROJECT_DETAILS,
  GET_PROJECT_RESOURCE,
  GET_PROJECT_RESOURCES,
  SAVE_PROJECT_DETAILS,
  SAVE_PROJECT_LOADING,
  SET_PROJECT_ANALYTICS_LOADING,
  SET_PROJECT_DETAILS_LOADING,
  SET_PROJECT_LOADING,
  SET_PROJECT_VIEW_MODE,
} from "/@src/redux/contants";
import { SAVE_PROJECT } from "/@src/redux/contants";
import { ProjectStatus } from "/@src/views/app/project/ProjectType";

const INIT_STATE = {
  project: null,
  projectNotFound: false,
  projectDetails: null,
  loading: false,
  saveProjectLoading: false,
  detailsLoading: false,
  viewMode: "READ",
  canEdit: false,
  resources: [],
  accessKeys: [],
  projectResource: null,
};

const projectReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROJECT:
      return {
        ...state,
        project: action.payload,
        projectNotFound: false,
        canEdit: action.payload?.status === ProjectStatus.DRAFT,
      };
    case SAVE_PROJECT:
      return {
        ...state,
        project: action.payload,
        canEdit: action.payload?.status === ProjectStatus.DRAFT,
      };
    case GET_PROJECT_DETAILS:
      return { ...state, projectDetails: action.payload };
    case SAVE_PROJECT_DETAILS:
      return { ...state, projectDetails: action.payload };
    case SET_PROJECT_LOADING:
      return {
        ...state,
        loading: action.payload,
        project: action.payload ? null : state.project,
        projectDetails: action.payload ? null : state.projectDetails,
      };
    case SET_PROJECT_DETAILS_LOADING:
      return {
        ...state,
        detailsLoading: action.payload,
        projectDetails: action.payload ? null : state.projectDetails,
      };
    case SAVE_PROJECT_LOADING:
      return { ...state, saveProjectLoading: action.payload };
    case SET_PROJECT_VIEW_MODE:
      return { ...state, viewMode: action.payload };
    case GET_PROJECT_RESOURCES:
      return { ...state, resources: action.payload };
    case GET_PROJECT_RESOURCE:
      return { ...state, projectResource: action.payload };
    case GET_ACCESS_KEYS:
      return { ...state, accessKeys: action.payload };
    default:
      return { ...state };
  }
};

export default projectReducer;
